// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ra-0";